import { createContext } from 'react';

const RequestACallbackContext = createContext({});

export default RequestACallbackContext;
